/* eslint-disable max-len */
import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoInteresadosView',
    name: 'MtoInteresadosView',
    component: () =>
      import('../views/interesados/InteresadosView.vue'),
    meta: {
      title: 'Buscador Interesados',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoInteresadosView'),
      bread: {
        path: [
          'Interesados',
        ],
      },
    },
    children: [
      {
        path: 'MtoInteresadoDetalleEditView/:id',
        name: 'MtoInteresadoDetalleEditView',
        component: () =>
          import('../views/interesados/detalle-interesado/InteresadoDetalleView.vue'),
        meta: {
          title: 'Editar Interesado',
          requiresAuthentication: true,
          requiresAuthorization: false,
          roles: getRolesPantalla('MtoInteresadoDetalleEditView'),
          bread: {
            path: [
              'Interesados',
              {
                label: 'Buscador Interesados',
                routeLocation: {name: 'MtoInteresadosView'},
              },
            ],
          },
        },
      },
      {
        path: 'MtoInteresadoConsolidacionView/:id/:id2',
        name: 'MtoInteresadoConsolidacionView',
        component: () =>
          import('../views/interesados/interesados-consolidacion/InteresadoConsolidacionView.vue'),
        meta: {
          title: 'Consolidar Interesado',
          requiresAuthentication: true,
          requiresAuthorization: false,
          bread: {
            path: [
              'Interesados',
              {
                label: 'Buscador Interesados',
                routeLocation: {name: 'MtoInteresadosView'},
              },
            ],
          },
        },
      },
    ],
  },
];

